<template>
    <div class="tccc-d">
        <el-dialog
            v-model="dialogVisible"
            width="1300"
            :close-on-click-modal="false"
            destroy-on-close
            title="回访跟进"
            :fullscreen="true"
            :before-close="beforeClose"
            @open="open"
            @close="close"
            top="2vh"
        >
            <div class="tccc_main" v-loading="loading">
                <div class="tccc_call">
                    <div class="call_info">
                        <SvgIcon iconClass="tcccAvatar" />
                        <p>
                            <phonyNum :showEye="false"  :primitive=" studentInfo.phone" />
                        </p>
                        <p>{{ studentInfo.city }}</p>
                        <p>主叫号码：{{ outboundCallNumber }}</p>
                    </div>
                    <div
                        class="call"
                        :style="
                            isKeepCall
                                ? 'filter:grayscale(1); pointer-events: none;'
                                : ''
                        "
                    >
                        <SvgIcon
                            @click="startOutboundCall"
                            iconClass="tcccTelephone1"
                        />
                    </div>
                </div>
                <div class="tccc_followup">
                    <!-- <header>回访跟进</header> -->
                    <div class="base_info">
                        <div class="left" >
                            <template v-if="isInnerStudent">
                                <p class="title">基本信息</p>
                                <ul class="ul">
                                    <li>
                                        <span class="label">姓名：</span>
                                        <span class="value">{{
                                            studentInfo.name || "-"
                                        }}</span>
                                    </li>
                                    <li>
                                        <span class="label">联系电话：</span>
                                        <span class="value">
                                            <phonyNum :primitive=" studentInfo.phone" />
                                        </span>
                                    </li>
                                    <li>
                                        <span class="label">指派校区：</span>
                                        <span class="value">{{
                                            studentInfo.schoolName || "-"
                                        }}</span>
                                    </li>
                                    <li>
                                        <span class="label">市场人员：</span>
                                        <span class="value">{{
                                            studentInfo.marketerName || "-"
                                        }}</span>
                                    </li>
                                    <li>
                                        <span class="label">咨询顾问：</span>
                                        <span class="value">{{
                                            studentInfo.ownerName || "-"
                                        }}</span>
                                    </li>
                                    <li
                                        v-for="(item, index) in sourcePathList"
                                        :key="index"
                                    >
                                        <span class="label">{{
                                            `${numberToChinese(index + 1)}级渠道：`
                                        }}</span>
                                        <span class="value">{{ item }}</span>
                                    </li>
                                    <li>
                                        <span class="label">合作商：</span>
                                        <span class="value">{{
                                            studentInfo.partnersName || "-"
                                        }}</span>
                                    </li>
                                </ul>
                            </template>
                            <template v-if="!isInnerStudent">
                                <addStudent :recordId="recordId" @success="addSuccess"/>
                            </template>
                            <el-divider border-style="dashed" />
                            <div class="form">
                                <div class="header">
                                    <span class="title">新建跟进记录</span>
                                    <div>
                                        <!-- <el-button type="info"
                                            @click="getRecordUrl"
                                            >播放语音</el-button
                                        > -->
                                        <el-button
                                            type="primary"
                                            @click="saveForm"
                                            >保存回访记录</el-button
                                        >
                                    </div>
                                </div>
                                <addFollowupForm
                                    ref="followRef"
                                    :type="studentType"
                                    :canFiles="false"
                                    callType="电话"
                                    :showPlayAudio="true"
                                    :id="studentInfo.id"
                                    @playAudio="getRecordUrl"
                                />
                            </div>
                        </div>
                        <div class="right" v-if="isInnerStudent">
                            <p class="title">历史跟进记录</p>
                            <div class="timeline">
                                <template v-if="followList.length">
                                    <div
                                        v-for="(item, index) in followList"
                                        :key="index"
                                    >
                                        <h3 class="day">{{ item.day }}</h3>
                                        <el-timeline>
                                            <el-timeline-item
                                                v-for="(
                                                    line, i
                                                ) in item.children"
                                                :key="i"
                                                :timestamp="line.time"
                                                center
                                                placement="top"
                                            >
                                                <el-card shadow="never">
                                                    <p
                                                        style="
                                                            text-align: right;
                                                        "
                                                    >
                                                        <el-button
                                                            link
                                                            size="small"
                                                            type="primary"
                                                            @click="
                                                                returnVisit(
                                                                    studentInfo.id,
                                                                    studentType
                                                                )
                                                            "
                                                            >查看详情</el-button
                                                        >
                                                    </p>
                                                    <p class="content">
                                                        {{ line.content }}
                                                    </p>
                                                    <p>
                                                        沟通方式：{{
                                                            line.type
                                                        }}
                                                    </p>
                                                </el-card>
                                            </el-timeline-item>
                                        </el-timeline>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
         <!-- 录音 -->
        <audioDialog
            v-model:visible="audioHandler.show"
            :url="audioHandler.url"
        />
        <audioToText
             v-model:show="audioToTextHandler.show"
             :id="audioToTextHandler.row.lastId"
             :row="audioToTextHandler.row"
             :file-url="audioToTextHandler.row.fileUrl"
             :recordId="audioToTextHandler.row.recordId"
        />
    </div>
</template>

<script setup>
import addStudent from "./addStudent.vue";
import { initTccc } from "@/utils/Tccc";
import dayjs from "dayjs";
import {
    addCallRecordApi,
    saveCallRecordApi,
    getRecordUrlApi,
} from "@/api/Tccc/index";
import audioToText from "./audioToText.vue";
import { selectFollowList } from "@/api/studentmange";
import { ElMessage, ElMessageBox } from "element-plus";
import addFollowupForm from "@/views/studentmange/cmp/flowup-record/v2/addForm.vue";
import audioDialog from "./audioDialog.vue";
import phonyNum from '@/components/hideNum/phonyNum.vue'
const dialogVisible = defineModel("show", {
    default: false,
    required: false,
});
//外呼 sessionId
const sessionId = ref("");
const recordId = ref("");
//正在通话
const isKeepCall = ref(false);
const { currentRow, type,isInnerStudent, acceptSessionId} = defineProps({
    currentRow: {
        type: Object,
        default: () => ({}),
        required: false,
    },
    type: {
        type: String,
        default: "1", //意向学员 1  报名学员 2
    },
    isInnerStudent:{
        type:Boolean, //是否内部学员
        default:true
    },
    acceptSessionId:{
        type: String,
        default: "",
    }
});
const studentInfo = ref({})
const studentType = ref('1')
const router = useRouter();
const sourcePathList = computed(() => {
    if (studentInfo.value.sourcePath) {
        const arr = studentInfo.value.sourcePath.split("/").filter((it) => !!it);
        return arr;
    }
    return [];
});
const loading = ref(false);
const followList = ref([]);
function getFlowList(reset) {
    let params = {
        id: studentInfo.value.id,
        type: studentType.value,
    };
    selectFollowList(params)
        .then((res) => {
            if (res.data) {
                let arr = [];
                let keys = Object.keys(res.data).sort((a, b) => {
                    if (dayjs(`${a}`).isAfter(`${b}`)) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
                keys.forEach((key) => {
                    let children = res.data[key] || [];
                    if (children?.length) {
                        if (reset) {
                            children.forEach((item) => {
                                editOpt.value[item.id] = false;
                            });
                        }
                        //时间排序
                        children = children.sort((a, b) => {
                            if (
                                dayjs(`${a.date} ${a.time}`).isAfter(
                                    `${b.date} ${b.time}`
                                )
                            ) {
                                return -1;
                            } else {
                                return 1;
                            }
                        });
                    }
                    let item = { day: key, children: children };
                    arr.push(item);
                });
                followList.value = arr;
            }
        })
        .finally(() => {});
}
function tcccEnd(response) {
    isKeepCall.value = false;
}
const outboundCallNumber = ref("");
const tokenInfo = ref({})
const open = async () => {
    sessionId.value = acceptSessionId;
    studentInfo.value = {...currentRow,...studentInfo.value};
    studentType.value = type;
    if(isInnerStudent){
        getFlowList();
    }
    loading.value = true;
    const res = await initTccc(false);
    loading.value = false;
    if (res) {
        tokenInfo.value = res;
        outboundCallNumber.value = res.outboundCallNumber;
        if(tokenInfo.value.outboundDialerProvider == 'ali'){
            CTILink.event("sipSessionTerminate", function() {
                console.log('Sip通话结束')
                isKeepCall.value = false;
            });
        }else{
            if (window.tccc) {
                window.tccc.on(window.tccc.events.sessionEnded, tcccEnd);
            }
        }
        //呼入逻辑
        if(sessionId.value){
                await callSuccessHandler(sessionId.value)
        }
    }
};
const addSuccess = (val)=>{
    studentInfo.value= {
        ...val
    }
    studentType.value = '1';
}
const close = () => {
    sessionId.value = "";
    recordId.value = "";
    followList.value = [];
    studentInfo.value = {};
    studentType.value = "";
    if (window.tccc) {
        window.tccc.off(window.tccc.events.sessionEnded, tcccEnd);
    }
};
function numberToChinese(num) {
    if (isNaN(num) || num > 999999999999999 || num < -999999999999999) {
        return "数字超出范围";
    }

    if (num === 0) return "零";

    const units = ["", "十", "百", "千"];
    const bigUnits = ["", "万", "亿", "兆"];
    const digits = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];

    let negative = "";
    if (num < 0) {
        negative = "负";
        num = -num;
    }

    let str = "";
    let needZero = false;
    let zeroCount = 0;

    // 处理小数部分
    let decimalStr = "";
    const numStr = num.toString();
    if (numStr.includes(".")) {
        const decimalPart = numStr.split(".")[1];
        decimalStr = "点";
        for (let i = 0; i < decimalPart.length; i++) {
            decimalStr += digits[parseInt(decimalPart[i])];
        }
        num = Math.floor(num);
    }

    let unitPos = 0;

    while (num > 0) {
        const segment = num % 10000;
        if (segment > 0) {
            let segmentStr = "";
            let temp = segment;
            let pos = 0;

            while (temp > 0) {
                const d = temp % 10;
                if (d === 0) {
                    if (segmentStr !== "" && segmentStr[0] !== "零") {
                        segmentStr = "零" + segmentStr;
                    }
                } else {
                    segmentStr = digits[d] + units[pos] + segmentStr;
                }
                temp = Math.floor(temp / 10);
                pos++;
            }

            // 处理连续的零
            segmentStr = segmentStr.replace(/零+/g, "零");
            if (segmentStr.endsWith("零")) {
                segmentStr = segmentStr.slice(0, -1);
            }

            str = segmentStr + bigUnits[unitPos] + str;
        } else {
            // 当前段全为零，标记需要补零
            zeroCount++;
        }

        num = Math.floor(num / 10000);
        unitPos++;
    }

    // 处理连续的零
    str = str.replace(/零+/g, "零");

    // 处理 "一十" 开头的特殊情况
    if (str.startsWith("一十")) {
        str = str.substring(1);
    }

    return negative + str + decimalStr;
}
const followRef = ref(null);
const beforeClose = async (done) => {
    if (recordId.value) {
        const res = await followRef.value.validateForm();
        if (res) {
            done();
        } else {
            ElMessageBox.confirm(
                "<p>无法关闭弹窗，请先填写跟进记录中带<span style='color:red;'>*</span>的内容</p>",
                "提示",
                {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                    appendTo: ".tccc_main",
                    dangerouslyUseHTMLString: true,
                }
            )
                .then(() => {})
                .catch(() => {});
        }
    } else {
        done();
    }
};
const saveForm = () => {
    if(!studentInfo.value.id){
        return ElMessage({
            type: "warning",
            message: "请先新建意向学员",
        });
    }
    followRef.value.submitAdd({ recordId: recordId.value }).then((res) => {
        dialogVisible.value = false;
        returnVisit( studentInfo.value.id,studentType.value)
    })
};
async function callSuccessHandler(sessionId) {
    try {
        const res = await addCallRecordApi({ sessionId,source:tokenInfo.value.outboundDialerProvider });
        recordId.value = res.msg;
        ElMessage({
            type: "warning",
            message: "通话正在被录音.....",
        });
    } catch (error) {
        ElMessage({
            type: "warning",
            message: "初始recordId失败",
        });
    }
}
function returnVisit(id, type) {
    let name = ''
    if(type == 1){
        name = 'Intention/detail'
        sessionStorage.setItem("intentionDetailPageActive", "followInfo");
    }else{
        name = 'Sign/detail';
        sessionStorage.setItem('signDetailPageActive', 'flowInfo');
    }
    router.push({
        name:name,
        query: {
            id: id,
            type: 'view',
        },
    });
}
const callByTx = ()=>{
    if (!window.tccc) {
        ElMessage({
            type: "warning",
            message: "无外呼实例，无法进行外呼",
        });
        return;
    }
    if (isKeepCall.value) {
        ElMessage({
            type: "warning",
            message: "已存在外呼，无法重复外呼",
        });
        return;
    }
    window.tccc.Call.startOutboundCall({
        phoneNumber: studentInfo.value.phone,
        // phoneNumber:"15629018018"
    })
        .then((res) => {
            sessionId.value = res.data.sessionId;
            isKeepCall.value = true;
            callSuccessHandler(sessionId.value);
        })
        .catch((err) => {
            const error = err.errorMsg;
            console.log("---------------", error);
        });
}
const callByAL = ()=>{
        const params = {
            tel: studentInfo.value.phone
        }
        CTILink.Agent.previewOutcall(params,function(res){
            console.log(res)
            if(res.code == '0'){
                sessionId.value = res.requestUniqueId;
                isKeepCall.value = true;
                callSuccessHandler(sessionId.value);
            }else{
                 ElMessage({
                    type: "warning",
                    message: res.msg,
                });
                return;
            }
        })
}
const startOutboundCall = () => {
    if(tokenInfo.value.outboundDialerProvider == 'ali'){
       callByAL()
    }else{
        callByTx()
    }

};
const audioHandler = reactive({
    show:false,
    url:""
})
const getRecordUrl = async ()=>{
    if(recordId.value){
       const { url } = await getRecordUrlApi(recordId.value)
       if(url){
            showAudioText(url)
       }else{
            ElMessage({
                type: "warning",
                message: "语音文件还未生成，请稍后",
            });
            return;
       }
    }else{
        ElMessage({
            type: "warning",
            message: "无法播放语音",
        });
        return;
    }
}
const audioToTextHandler = reactive({
    show:false,
    row:{}
})
const showAudioText = (fileUrl)=>{
    audioToTextHandler.row = {
        lastId:'-',
        studentName:studentInfo.value.name,
        schoolName:studentInfo.value.schoolName,
        returnVisitDate:'-',
        teacherName:studentInfo.value.ownerName,
        fileTime:'-',
        recordId:recordId.value,
        fileUrl
    }
    audioToTextHandler.show = true;
}
</script>
<style lang="scss">
t3c-sdk::part(transfer-button) {
    display: none;
}

t3c-sdk::part(invite-button) {
    display: none;
}

t3c-sdk::part(selfService-button) {
    display: none;
}

t3c-sdk::part(digits-button) {
    display: none;
}

#tcccSdkDomRoot {
    z-index: 4000;
}
</style>
<style lang="scss" scoped>
.tccc-d {
    .tccc_main {
        display: flex;

        .tccc_call {
            width: 200px;
            height: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #eee;
            flex-shrink: 1;

            .call_info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-top: 40px;

                :deep(.svg-icon) {
                    font-size: 100px;
                }

                p {
                    padding: 4px 0;
                    text-align: center;
                    color: #333;
                    font-size: 14px;
                }
            }

            .call {
                font-size: 80px;
                margin-top: 140px;
                cursor: pointer;
            }
        }

        .tccc_followup {
            flex: 1;

            header {
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                height: 48px;
                line-height: 48px;
                border-bottom: 1px solid #eee;
            }

            .base_info {
                display: flex;

                .left {
                    flex: 1;
                    padding: 16px;
                    box-sizing: border-box;
                    border-right: 1px solid #eee;

                    .title {
                        font-size: 14px;
                        font-weight: bold;
                    }

                    .ul {
                        display: flex;
                        flex-wrap: wrap;

                        li {
                            display: flex;
                            align-items: center;
                            margin-top: 20px;
                            margin-right: 16px;

                            .value {
                                margin-left: 4px;
                                color: #333;
                            }

                            .label {
                                color: #777;
                            }
                        }
                    }

                    .form {
                        height: calc(100vh - 280px);
                        overflow: auto;

                        .header {
                            display: flex;
                            align-items: center;
                            padding-bottom: 10px;

                            .title {
                                font-size: 16px;
                                margin-right: 12px;
                            }
                        }
                    }
                }

                .right {
                    width: 280px;

                    .title {
                        height: 36px;
                        line-height: 36px;
                        text-align: center;
                    }

                    .timeline {
                        height: calc(100vh - 140px);
                        overflow-y: auto;
                        padding: 8px;
                        box-sizing: border-box;

                        .day {
                            height: 32px;
                            line-height: 32px;
                            font-weight: bold;
                        }

                        .content {
                            color: #666;
                            font-size: 12px;
                            margin: 8px 0;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            /* 限制显示行数 */
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        :deep(.el-card) {
                            --el-card-padding: 8px;
                            color: #333;
                            font-size: 12px;

                            .el-card__body {
                                padding: 8px !important;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
